

































import { Component, Vue, Prop } from "vue-property-decorator";
import { RedCapital, RedCapitalConfig, SelectedCountry } from "@/configuration";
import { isRutValid, rutParser } from "@/utils";
import { Configuration } from "@/configuration";
import API from "@/api";
import Axios from "axios";
import { EventBus } from "@/main";

@Component({
	props: {
		labelInput: String,
		consultar: {
			type: String,
			default: 'SI'	
		},
		tipoUsuario: Number
	},
	data() {
		return {
			SelectedCountry,
			RedCapital,
			dni: "",
			oldDni: "",
			isFocus: false,
			icon: null,
			color: "",
			rules: {
				rut: [
					(v: any) =>
						!!v || `${RedCapitalConfig(SelectedCountry).DniName} es requerido`,
					(v: any) => v.length < 13 || "Maximo 12 caracteres",
					(v: any) =>
						isRutValid(v) || `${RedCapitalConfig(SelectedCountry).DniName} inválido`,
				]
			},
			iconRut: {
				load: false,
				ok: false
			},
			requestApi: false,
			countCallApi: 0,
			executeResponse: false,
			consultaApi : false,
		};
	},
	watch: {
		dni(){
				if(this.$data.dni != undefined){
					if(this.$data.dni == ''){
						// @ts-ignore
						this.dataResponseVacioChild();
						//this.$data.oldDni = '';
						this.$data.iconRut.ok = false;
						this.$data.requestApi = false; // cuando se borra el input se resetea esta variable que controla cuando hacer la consulta a la api
					}
					if(this.$data.dni != ''){
						this.$data.dni = this.$data.dni.split('.').join(); // Agregue esta liena para cuando desde mis operaciones o mis solicitudes envia el rut
						if(this.$data.dni != rutParser(this.$data.dni)){
							this.$data.dni = rutParser(this.$data.dni);
							if(isRutValid(this.$data.dni)){
								/* this.$data.requestApi = false;
								this.$data.executeResponse = true;
								// @ts-ignore
								this.callApi(this.$data.dni); */
								if(this.$data.oldDni != '' && rutParser(this.$data.oldDni) != rutParser(this.$data.dni)){
									this.$data.requestApi = false;
									this.$data.executeResponse = true;
								}
								if(!this.$data.requestApi){
									// @ts-ignore
									this.callApi(this.$data.dni);
								}
							}else{
								this.$data.iconRut.ok = false;
							}
						}
						/* else{
							if(isRutValid(this.$data.dni)){
								console.log('DNI != 2,2');
								// @ts-ignore
								this.callApi(this.$data.dni);	
							}
						} */
					}
				}else{
					this.$data.iconRut.ok = false;
					this.$data.requestApi = false;
				}
			
		},
		value(val) {
			if (SelectedCountry == "CL" || SelectedCountry == "PYME") {
				this.$data.dni = rutParser(val);
			} else {
				this.$data.dni = val;
			}
		}
	},
	created() {
		this.$data.dni = this.$props.value;
	},
	methods: {
		log(el: any, val: any) {
			if(val != ''){
				// @ts-ignore
				//this.callApi(val);
				if(!this.$data.requestApi){
					// @ts-ignore
					this.callApi(val);
				}
			}
		},
		callApi(val){
			val = rutParser(val);
			this.$data.dni = val;
			if(!this.$data.consultaApi){
				this.$data.consultaApi = true;
				// Inicia Carga
				this.$emit('dataResponseConsultandoParent', true);
			}
			
			
			if (isRutValid(val.toUpperCase()) && val.length >= 11) {
				this.$data.iconRut.load = true;
				this.$data.requestApi = true;
				Axios.get(`${Configuration.api.sii2}${val.toUpperCase()}`)
					.then((res: any) => {
						this.$data.oldDni = this.$data.dni;
						this.$data.iconRut.load = false;
						this.$data.iconRut.ok = true;
						this.$data.countCallApi = 0;
						this.$emit("input", this.$data.dni); // envia el valor del DNI hacia el componente papa
						if(this.$data.consultaApi){
							this.$data.consultaApi = false;
							// Termina Carga
							this.$emit('dataResponseConsultandoParent', false);
						}
						if(this.$props.consultar == 'SI'){
							EventBus.$emit("snack-success", 'El RUT ingresado es válido');
							// @ts-ignore
							this.dataResponseChild(res); //ENVIANDO LA DATA AL PAPÁ
						}else{
							if(this.$data.executeResponse){
								EventBus.$emit("snack-success", 'El RUT ingresado es válido');
								// @ts-ignore
								this.dataResponseChild(res); //ENVIANDO LA DATA AL PAPÁ
								this.$data.executeResponse = false;
							}
						}
					})
					.catch((error: any) => {
						if(this.$data.countCallApi == 4 ){
							this.$data.countCallApi = 0;
							// Rut Ok cuando falla se asume que es una persona sin GIRO
							this.$data.iconRut.ok = true;
							this.$data.iconRut.load = false;
							//this.$data.dni = "";
							this.$emit("input", this.$data.dni);
							if(this.$data.consultaApi){
								this.$data.consultaApi = false;
								// Termina Carga
								this.$emit('dataResponseConsultandoParent', false);
							}
							// @ts-ignore
							this.dataResponseChild({data:{actividades: [],fecha_inicio_actividades: "clarar y p",presenta_inicio_actividades: "NO",razon_social: "**", rutSinGiro: true}});
							// @ts-ignore
							//this.alertasRutChild({ show: true, mensaje: 'No es posible procesar su solicitud en estos momentos', tipo: false,})
							EventBus.$emit("snack-error", 'No es posible traer tus datos del SII en estos momentos');
						}else{
							this.$data.countCallApi++;
							// @ts-ignore
							this.callApi(val);
						}
					});
			}
		},
		dataResponseChild(data){
			this.$emit('dataResponseParent', data);
		},
		dataResponseVacioChild(){
			this.$emit('dataResponseVacioParent');
		}
	}
})
export default class DniField extends Vue {
	@Prop() tipoUsuario!: number;
	@Prop() value!: string;
	@Prop() label!: string;
	@Prop() prefix!: string;
	@Prop() suffix!: string;
	@Prop() unique!: string;
}
